import { render, staticRenderFns } from "./FeedWrapper.vue?vue&type=template&id=0c3fa362"
import script from "./FeedWrapper.vue?vue&type=script&lang=js"
export * from "./FeedWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports